//@flow
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { connect } from 'react-redux';
import { Button, Container, Row, Col, Modal, ModalHeader } from 'reactstrap';

import SEO from '../../constants/seo';
import TrekFilters from './TrekFilters/TrekFilters';
import { TrekCard } from '../../components/Cards';
import { fetchAllTreks } from '../../redux/actions/trekActions';
import type { TrekData } from '../../types/cards';
import { Page, Toggler, Loading } from '../../components';
import { useEffectOnFirstRender } from '../../hooks';

type Props = {
  treks: Array<TrekData>,
  fetchTreks: () => void,
  loading: boolean,
};

const mapStateToProps = ({ schema, trekFiltersType: { loading } }) => ({
  treks: Object.values(schema.treks.byId),
  loading,
});

const mapDispatchToProps = dispatch => ({
  fetchTreks: () => dispatch(fetchAllTreks()),
});

function TrekLists(props: Props) {
  useEffectOnFirstRender(() => {
    if (isEmpty(props.treks)) props.fetchTreks();
  });

  const { loading, treks } = props;
  const numberOfTreks = treks.length;

  return (
    <Page {...SEO.trekListings}>
      <Toggler>
        {({ on, toggle }) => (
          <main className="Card-Container">
            <Container>
              <Row>
                <TrekFilters />
                {loading && !on ? (
                  <Col>
                    <Loading size="small" />
                  </Col>
                ) : (
                  <Col xl="10" lg="9" md="9">
                    <Row>
                      <Col className="available-treks">
                        <Row>
                          <Col xs="12">
                            <h1 className="available-treks-title">
                              AVAILABLE TREKS{' '}
                              <small className="float-right d-block d-md-none">
                                <Button color="yellow" size="sm" onClick={toggle}>
                                  Filters
                                </Button>
                              </small>
                            </h1>{' '}
                          </Col>
                          {renderAvailableTreks()}
                        </Row>
                      </Col>
                    </Row>
                  </Col>
                )}
              </Row>

              <Modal isOpen={on} className="filters-modal">
                <ModalHeader toggle={toggle}>
                  <h3 className="res-view">Filters</h3>
                </ModalHeader>
                <TrekFilters />
                <div className="filter-sidebar pt-0">
                  <Button
                    className={`${loading ? 'btn-loading' : ''} btn-yellow`}
                    onClick={toggle}
                  >
                    See {numberOfTreks} Results
                  </Button>
                </div>
              </Modal>
            </Container>
          </main>
        )}
      </Toggler>
    </Page>
  );

  function renderAvailableTreks() {
    return !isEmpty(props.treks) ? (
      props.treks.map(trekList => (
        <Col xl="3" lg="4" sm="6" key={trekList.id}>
          <TrekCard cardData={trekList} />
        </Col>
      ))
    ) : (
      <Col md="12">
        <span>No treks available</span>
      </Col>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TrekLists);



// WEBPACK FOOTER //
// ./src/screens/TrekListings/TrekLists.jsx